import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formContainer", "typeField", "formTitle", "amountInput"]

  showIncome() {
    this.typeFieldTarget.value = "income"
    this.formTitleTarget.textContent = "Registrar Ingreso"
    this.formContainerTarget.classList.remove("hidden")
    this.formContainerTarget.classList.add("cash-drawer-form--income")
    this.formContainerTarget.classList.remove("cash-drawer-form--expense")
    this.amountInputTarget.focus()
  }

  showExpense() {
    this.typeFieldTarget.value = "expense"
    this.formTitleTarget.textContent = "Registrar Retiro"
    this.formContainerTarget.classList.remove("hidden")
    this.formContainerTarget.classList.remove("cash-drawer-form--income")
    this.formContainerTarget.classList.add("cash-drawer-form--expense")
    this.amountInputTarget.focus()
  }

  cancel() {
    this.formContainerTarget.classList.add("hidden")
    this.formContainerTarget.classList.remove("cash-drawer-form--income", "cash-drawer-form--expense")
    // Reset form fields
    const form = this.formContainerTarget.querySelector("form")
    if (form) form.reset()
  }
}
